import { render, staticRenderFns } from "./EiProduct.vue?vue&type=template&id=caf91b0c&scoped=true&"
import script from "./EiProduct.vue?vue&type=script&lang=js&"
export * from "./EiProduct.vue?vue&type=script&lang=js&"
import style0 from "./EiProduct.vue?vue&type=style&index=0&id=caf91b0c&lang=scss&scoped=true&"
import style1 from "./EiProduct.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf91b0c",
  null
  
)

component.options.__file = "EiProduct.vue"
export default component.exports